import * as z from 'zod';

import { CustomTemplateId, LosId } from '../../BrandedIds';
import { BulkBorrowerAccess } from '../../loan/DocumentAccess';

/**
 * One row of a bulk custom-template generation request. Renders the
 * template against the loan and saves the resulting PDF to the loan's
 * documents with the requested borrower access.
 */
export const GenerateCustomTemplateRow = z.object({
  loanId: LosId,
  templateId: CustomTemplateId.describe('The id of the custom template to render'),
  borrowerAccess: BulkBorrowerAccess.default('all').describe(
    'Which borrowers can see the generated document in the portal. Defaults to all when blank.',
  ),
});
export type GenerateCustomTemplateRow = z.infer<typeof GenerateCustomTemplateRow>;

export const GENERATE_CUSTOM_TEMPLATE_ROW_REQUIRED_FIELDS = Object.keys(GenerateCustomTemplateRow.shape).filter(
  (key) => !GenerateCustomTemplateRow.shape[key as keyof typeof GenerateCustomTemplateRow.shape].isOptional(),
);
